import React, { useEffect } from 'react';
import styled, { css } from 'styled-components';
import Slider from 'react-slick';
import { Fancybox as NativeFancybox } from '@fancyapps/ui/dist/fancybox.esm.js';
import '@fancyapps/ui/dist/fancybox.css';

import { media, SlickStyles } from '../../utils/styles';

const Section = styled.div`
  margin: 0 -16px 120px;
  ${media.phone} {
    width: 208px;
    margin: 0 auto 120px;
  }
`;

const Slide = styled.div`
  position: relative;
  padding: 0 16px;
  ${media.phone} {
    padding: 0;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 392px;
  object-fit: cover;
  ${media.phone} {
    height: 274px;
  }
`;

const Play = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 80px;
  height: 80px;
  margin: auto;
  &:hover {
    background: rgba(255, 255, 255, 0.5);
  }
`;

const ArrowButton = styled.button`
  display: flex;
  background: #f4f4f4;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0;
  top: 0;
  left: -64px;
  margin: auto 0;
  @media (min-width: 768px) and (max-width: 1239px) {
    top: auto;
    bottom: -60px;
    left: 16px;
  }
  ${({ $next }) =>
    $next &&
    css`
      left: auto;
      right: -64px;
      @media (min-width: 768px) and (max-width: 1239px) {
        right: 16px;
        left: auto;
      }
    `}
`;

const PrevArrow = props => (
  <ArrowButton {...props}>
    <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.93839 14C6.64265 14 6.40758 13.8913 6.20284 13.6894L0.38673 7.87354C0.12891 7.60954 0.00758314 7.33777 0 7.00388C0 6.66999 0.121327 6.39046 0.38673 6.13422L6.20284 0.310593C6.40758 0.108708 6.65024 0 6.93839 0C7.52986 0 8 0.48142 8 1.07931C8 1.37438 7.87867 1.65391 7.66635 1.87133L2.50995 7.00388L7.66635 12.1287C7.87867 12.3461 8 12.6256 8 12.9207C8 13.5186 7.52986 14 6.93839 14Z"
        fill="#222222"
      />
    </svg>
  </ArrowButton>
);

const NextArrow = props => (
  <ArrowButton {...props} $next>
    <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.06161 14C1.35735 14 1.59242 13.8913 1.79716 13.6894L7.61327 7.87354C7.87109 7.60954 7.99242 7.33777 8 7.00388C8 6.66999 7.87867 6.39046 7.61327 6.13422L1.79716 0.310593C1.59242 0.108708 1.34976 0 1.06161 0C0.470142 0 0 0.48142 0 1.07931C0 1.37438 0.121327 1.65391 0.333649 1.87133L5.49005 7.00388L0.333649 12.1287C0.121327 12.3461 0 12.6256 0 12.9207C0 13.5186 0.470142 14 1.06161 14Z"
        fill="#222222"
      />
    </svg>
  </ArrowButton>
);

export const TestimonialsSlider = ({ testimonials }) => {
  useEffect(() => {
    NativeFancybox.bind('[data-fancybox]', {});

    return () => {
      NativeFancybox.destroy();
    };
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    arrows: true,
    speed: 500,
    autoplaySpeed: 3000,
    autoplay: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    lazyLoad: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <Section>
      <SlickStyles />
      <Slider {...settings}>
        {testimonials.map((testimonial, index) => (
          <Slide key={index}>
            <Image src={testimonial.cover.url} alt="" />
            <Play href={testimonial.video.url} data-fancybox="gallery">
              <svg
                width="13"
                height="14"
                viewBox="0 0 13 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M13 7L0.875648 14L0.875648 -5.29972e-07L13 7Z" fill="white" />
              </svg>
            </Play>
          </Slide>
        ))}
      </Slider>
    </Section>
  );
};
